module.exports = __webpack_public_path__ + "static/assets/11a377d4473321b3397440c222212b96.png";